/**
 * Datos de demostración para Bizantino Gelato
 * Se inicializan automáticamente si no existen en localStorage
 */

// Sucursales de ejemplo
export const demoBranches = [
  {
    id: "branch_1",
    business_name: "Bizantino Gelato - Sucursal Centro",
    commercial_business: "Heladería Artesanal",
    phone: "56912345678",
    dni: "76.123.456-7",
    email: "centro@bizantinogelato.cl",
    region: "Región Metropolitana",
    province: "Santiago",
    commune: "Santiago",
    address: "Av. Providencia 1234",
    created: new Date().toISOString(),
    modified: new Date().toISOString(),
  },
  {
    id: "branch_2",
    business_name: "Bizantino Gelato - Sucursal Las Condes",
    commercial_business: "Heladería Artesanal",
    phone: "56987654321",
    dni: "76.234.567-8",
    email: "lascondes@bizantinogelato.cl",
    region: "Región Metropolitana",
    province: "Santiago",
    commune: "Las Condes",
    address: "Av. Apoquindo 5678",
    created: new Date().toISOString(),
    modified: new Date().toISOString(),
  },
];

// Ingredientes nutricionales de ejemplo
export const demoProducts = [
  {
    id: "prod_1",
    name: "Leche Entera",
    supplier_company: "Soprole",
    measurement_unit: "ml",
    branch: "branch_1",
    is_nutritional_ingredient: true,
    // Valores nutricionales por 100ml
    energy_kcal: 61.0,
    proteins_g: 3.1,
    total_fats_g: 3.2,
    saturated_fats_g: 2.0,
    monounsaturated_fats_g: 0.9,
    polyunsaturated_fats_g: 0.1,
    cholesterol_mg: 10.0,
    carbohydrates_g: 4.7,
    total_sugars_g: 4.7,
    sodium_mg: 40.0,
    dietary_fiber_g: 0.0,
    is_for_sale: false,
    tracks_inventory: true,
    created: new Date().toISOString(),
    modified: new Date().toISOString(),
  },
  {
    id: "prod_2",
    name: "Crema de Leche",
    supplier_company: "Colun",
    measurement_unit: "ml",
    branch: "branch_1",
    is_nutritional_ingredient: true,
    energy_kcal: 345.0,
    proteins_g: 2.1,
    total_fats_g: 35.0,
    saturated_fats_g: 22.0,
    monounsaturated_fats_g: 10.0,
    polyunsaturated_fats_g: 1.5,
    cholesterol_mg: 120.0,
    carbohydrates_g: 3.0,
    total_sugars_g: 3.0,
    sodium_mg: 30.0,
    dietary_fiber_g: 0.0,
    is_for_sale: false,
    tracks_inventory: true,
    created: new Date().toISOString(),
    modified: new Date().toISOString(),
  },
  {
    id: "prod_3",
    name: "Azúcar Refinada",
    supplier_company: "Iansa",
    measurement_unit: "g",
    branch: "branch_1",
    is_nutritional_ingredient: true,
    energy_kcal: 400.0,
    proteins_g: 0.0,
    total_fats_g: 0.0,
    saturated_fats_g: 0.0,
    monounsaturated_fats_g: 0.0,
    polyunsaturated_fats_g: 0.0,
    cholesterol_mg: 0.0,
    carbohydrates_g: 100.0,
    total_sugars_g: 100.0,
    sodium_mg: 0.0,
    dietary_fiber_g: 0.0,
    is_for_sale: false,
    tracks_inventory: true,
    created: new Date().toISOString(),
    modified: new Date().toISOString(),
  },
  {
    id: "prod_4",
    name: "Dextrosa",
    supplier_company: "Química Universal",
    measurement_unit: "g",
    branch: "branch_1",
    is_nutritional_ingredient: true,
    energy_kcal: 400.0,
    proteins_g: 0.0,
    total_fats_g: 0.0,
    saturated_fats_g: 0.0,
    monounsaturated_fats_g: 0.0,
    polyunsaturated_fats_g: 0.0,
    cholesterol_mg: 0.0,
    carbohydrates_g: 100.0,
    total_sugars_g: 100.0,
    sodium_mg: 0.0,
    dietary_fiber_g: 0.0,
    is_for_sale: false,
    tracks_inventory: true,
    created: new Date().toISOString(),
    modified: new Date().toISOString(),
  },
  {
    id: "prod_5",
    name: "Yema de Huevo",
    supplier_company: "Huevos Don Pollo",
    measurement_unit: "unidad",
    branch: "branch_1",
    is_nutritional_ingredient: true,
    // Valores por 100g (aproximadamente 5 yemas)
    energy_kcal: 322.0,
    proteins_g: 15.9,
    total_fats_g: 26.5,
    saturated_fats_g: 9.5,
    monounsaturated_fats_g: 11.7,
    polyunsaturated_fats_g: 4.2,
    cholesterol_mg: 1234.0,
    carbohydrates_g: 3.6,
    total_sugars_g: 0.6,
    sodium_mg: 48.0,
    dietary_fiber_g: 0.0,
    is_for_sale: false,
    tracks_inventory: true,
    created: new Date().toISOString(),
    modified: new Date().toISOString(),
  },
];

// Recetas de ejemplo
export const demoRecipes = [
  {
    id: "recipe_1",
    name: "Helado de Leche Clásico",
    code: "HEL-LEC-001",
    description: "Helado artesanal de leche tradicional",
    branch: "branch_1",
    recipe_type: "NUTRITIONAL_RECIPE",
    status: "ACTIVE",
    total_yield_grams: 6700,
    has_nutritional_calculation: false,
    created: new Date().toISOString(),
    modified: new Date().toISOString(),
  },
];

// Ingredientes de recetas de ejemplo
export const demoRecipeIngredients = [
  {
    id: "ing_1",
    recipe: "recipe_1",
    ingredient: "prod_1", // Leche Entera
    quantity: 5000,
    unit: "ml",
    created: new Date().toISOString(),
  },
  {
    id: "ing_2",
    recipe: "recipe_1",
    ingredient: "prod_2", // Crema de Leche
    quantity: 500,
    unit: "ml",
    created: new Date().toISOString(),
  },
  {
    id: "ing_3",
    recipe: "recipe_1",
    ingredient: "prod_3", // Azúcar Refinada
    quantity: 1000,
    unit: "g",
    created: new Date().toISOString(),
  },
  {
    id: "ing_4",
    recipe: "recipe_1",
    ingredient: "prod_4", // Dextrosa
    quantity: 200,
    unit: "g",
    created: new Date().toISOString(),
  },
];

/**
 * Inicializar datos de demo si no existen
 * Con validación robusta de guardado en localStorage
 */
export const initializeDemoData = () => {
  try {
    const { storage, STORAGE_KEYS } = require("../api/config");
    
    // Inicializar sucursales
    if (!storage.get(STORAGE_KEYS.BRANCHES, null)) {
      try {
        storage.set(STORAGE_KEYS.BRANCHES, demoBranches);
        // Verificar que se guardó correctamente
        const savedBranches = storage.get(STORAGE_KEYS.BRANCHES, []);
        if (savedBranches.length !== demoBranches.length) {
          console.error("Error: Las sucursales no se inicializaron correctamente");
        } else {
          console.log("✓ Sucursales inicializadas correctamente");
        }
      } catch (error) {
        console.error("Error inicializando sucursales:", error);
      }
    }
    
    // Inicializar productos
    if (!storage.get(STORAGE_KEYS.PRODUCTS, null)) {
      try {
        storage.set(STORAGE_KEYS.PRODUCTS, demoProducts);
        // Verificar que se guardó correctamente
        const savedProducts = storage.get(STORAGE_KEYS.PRODUCTS, []);
        if (savedProducts.length !== demoProducts.length) {
          console.error("Error: Los productos no se inicializaron correctamente");
        } else {
          console.log("✓ Productos inicializados correctamente");
        }
      } catch (error) {
        console.error("Error inicializando productos:", error);
      }
    }
    
    // Inicializar recetas
    if (!storage.get(STORAGE_KEYS.RECIPES, null)) {
      try {
        storage.set(STORAGE_KEYS.RECIPES, demoRecipes);
        // Verificar que se guardó correctamente
        const savedRecipes = storage.get(STORAGE_KEYS.RECIPES, []);
        if (savedRecipes.length !== demoRecipes.length) {
          console.error("Error: Las recetas no se inicializaron correctamente");
        } else {
          console.log("✓ Recetas inicializadas correctamente");
        }
      } catch (error) {
        console.error("Error inicializando recetas:", error);
      }
    }
    
    // Inicializar ingredientes de recetas
    if (!storage.get(STORAGE_KEYS.RECIPE_INGREDIENTS, null)) {
      try {
        storage.set(STORAGE_KEYS.RECIPE_INGREDIENTS, demoRecipeIngredients);
        // Verificar que se guardó correctamente
        const savedIngredients = storage.get(STORAGE_KEYS.RECIPE_INGREDIENTS, []);
        if (savedIngredients.length !== demoRecipeIngredients.length) {
          console.error("Error: Los ingredientes de recetas no se inicializaron correctamente");
        } else {
          console.log("✓ Ingredientes de recetas inicializados correctamente");
        }
      } catch (error) {
        console.error("Error inicializando ingredientes de recetas:", error);
      }
    }
    
    // Inicializar sucursal activa (primera sucursal por defecto)
    if (!storage.get(STORAGE_KEYS.ACTIVE_BRANCH, null)) {
      try {
        const firstBranchId = demoBranches[0]?.id;
        if (firstBranchId) {
          storage.set(STORAGE_KEYS.ACTIVE_BRANCH, firstBranchId);
          // Verificar que se guardó correctamente
          const savedBranch = storage.get(STORAGE_KEYS.ACTIVE_BRANCH);
          if (savedBranch !== firstBranchId) {
            console.error("Error: La sucursal activa no se inicializó correctamente");
          } else {
            console.log("✓ Sucursal activa inicializada correctamente");
          }
        }
      } catch (error) {
        console.error("Error inicializando sucursal activa:", error);
      }
    }
    
    console.log("✓ Inicialización de datos demo completada");
  } catch (error) {
    console.error("Error crítico en inicialización de datos demo:", error);
    // No lanzar el error para que la app pueda seguir funcionando
  }
};

